import React, { FC } from 'react';
import viewingContact from '../../../assets/viewingContact.png';
import viewingContactNavigation from '../../../assets/viewingContactNavigation.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpImage, HelpTitle } from './HelpElements';

const ViewingContactsHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('viewingContactsHelp');

    return (
        <>
            <HelpTitle>{t('viewingContactsHelp_Title')}</HelpTitle>
            <HelpBody>{t('viewingContactsHelp_purpose')}</HelpBody>
            <HelpImage size={'medium'} src={viewingContactNavigation} />
            <HelpBody>{t('viewingContactsHelp_overview')}</HelpBody>
            <HelpImage size={'xlarge'} src={viewingContact} />
        </>
    );
};

export { ViewingContactsHelp };
